<template>
    <DanhSachKhaiBaoVeDesktopVue v-if="!isMobile" />
    <DanhSachKhaiBaoVeMobileVue v-if="isMobile" />
</template>
<script>
import DanhSachKhaiBaoVeDesktopVue from "./Desktop/index.vue";
import DanhSachKhaiBaoVeMobileVue from "./Mobile/index.vue";
export default {
    components: {
        DanhSachKhaiBaoVeDesktopVue,
        DanhSachKhaiBaoVeMobileVue,
    },
    computed: {
        isMobile: {
            get() {
                return this.$store.state.ManHinh.isMobile;
            },
            set(data) {
                this.$store.commit("ManHinh/Set", {
                    key: "isMobile",
                    data: data,
                });
            },
        },
    },
};
</script>
<style scoped></style>
